import * as React from 'react';
import autobind from 'autobind-decorator';
import { ListGroup } from 'react-bootstrap';
import '../Assets/videoStud.sass';
import { toTime } from 'Utils/common';

export interface IVideoTOCProps {
    markers: any;
    clickCallback: any;
}


export default class VideoTOC extends React.Component<IVideoTOCProps,{}> {
    constructor(props: IVideoTOCProps) {
        super(props);
    }
    
    public handleClick(index) {
        this.props.clickCallback(index);
        console.log('handleClick')
        return false;
    }
    

    public render() {
        var markers = this.props.markers.map(
            (marker, index) => {
                return (
                    <ListGroup.Item key={marker.id} action onClick={this.handleClick.bind(this, index)}>
                        {marker.title}
                        {marker.type === 'S' ? marker.title : `Quiz : ${marker.quiz_title}`}
                        <span style={{ float: 'right' }}>{toTime(marker.time)}</span>
                    </ListGroup.Item>
                )
            }
        );
        return (

            <ListGroup>
                {markers}
            </ListGroup>

        );
    }
}
